

export default function() {
  /**
   * Sanitises the analytics properties, adding any standard properties it can.
   */
  var analyticsProperties = function(iframeElement, properties) {
    properties = properties || {};
    properties.video_url = iframeElement.src;


    return properties;
  };

  /**
   * Fire the "Video Completed" event once the video has ended.
   */
  var videoEnded = function() {
    this.fireEvent('Video Completed');
  };
  /**
   * Fire the "Video Paused" event once the video is paused.
   */
  var videoPaused = function() {
    this.fireEvent('Video Paused');
  };
  /**
   * Fire the "Video Started" event when the video first plays.
   */
  var videoPlayed = function() {
    if (! this.started) {
      this.started = true;

      this.fireEvent('Video Started');
    }
  };


  if (! window.CollectiveShift.Analytics.VideoEmbeds) {
    window.CollectiveShift.Analytics.VideoEmbeds = {};
  }


  if (! window.CollectiveShift.Analytics.VideoEmbeds.isVimeo) {
    window.CollectiveShift.Analytics.VideoEmbeds.isVimeo = function(iframeElement) {
      var result = false;

      if (iframeElement && iframeElement.src) {
        if (iframeElement.src.includes('vimeo.com')) {
          result = true;
        }
      }


      return result;
    };
  }


  if (! window.CollectiveShift.Analytics.VideoEmbeds.isYouTube) {
    window.CollectiveShift.Analytics.VideoEmbeds.isYouTube = function(iframeElement) {
      var result = false;

      if (iframeElement && iframeElement.src) {
        if (iframeElement.src.includes('youtube.com')) {
          result = true;
        }
      }


      return result;
    };
  }


  if (! window.CollectiveShift.Analytics.VideoEmbeds.VimeoFactory) {
    var Vimeo = function(element, analytics) {
      this.element = element;
      this.analytics = analytics;

      this.videoPlayed = this.videoPlayed.bind(this);
      this.videoEnded = this.videoEnded.bind(this);
      this.videoPaused = this.videoPaused.bind(this);
      this.timeUpdated = this.timeUpdated.bind(this);
    }
    Vimeo.prototype.started = false;
    Vimeo.prototype.playbackPercentage = 0;
    Vimeo.prototype.videoPlayed = videoPlayed;
    Vimeo.prototype.videoEnded = videoEnded;
    Vimeo.prototype.videoPaused = videoPaused;
    /*
    * Trigger the various "% complete" events as the video plays.
    */
    Vimeo.prototype.timeUpdated = function(event) {
      var percentage = Math.round(event.percent * 100);

      if ((percentage >= 25) && (this.playbackPercentage < 25)) {
        this.fireEvent('Video Watched 25%');
      }
      if ((percentage >= 50) && (this.playbackPercentage < 50)) {
        this.fireEvent('Video Watched 50%');
      }
      if ((percentage >= 75) && (this.playbackPercentage < 75)) {
        this.fireEvent('Video Watched 75%');
      }

      // update the stored value for next time.
      this.playbackPercentage = percentage;
    };
    Vimeo.prototype.initialise = function() {
      if (window.Vimeo) {
        this.player = new window.Vimeo.Player(this.element);

        this.player.on('ended', this.videoEnded);
        this.player.on('play', this.videoPlayed);
        this.player.on('pause', this.videoPaused);
        this.player.on('timeupdate', this.timeUpdated);

        this.titlePromise = this.player.getVideoTitle();
      }
    };
    Vimeo.prototype.fireEvent = function(eventName) {
      var properties = Object.assign({}, this.analytics);

      this.titlePromise.then(function(title) {
        properties.video_name = title;

        if (window.CSAnalytics) {
          window.CSAnalytics(eventName, properties);
        }
      });
    };

    window.CollectiveShift.Analytics.VideoEmbeds.Vimeo = Vimeo;
  }


  if (! window.CollectiveShift.Analytics.VideoEmbeds.VimeoFactory) {
    /**
     * A factory class for loading and initialising the Vimeo Iframe API for
     * analytics.
     * We load the Iframe API dynamically, as the documentation suggests, so we
     * use this factory to handle that loading, and delaying any actual
     * processing until the API library is ready.
     */
    var VimeoFactory = function() {
      this.backlog = [];

      this.onLoad = this.onLoad.bind(this);
    };
    VimeoFactory.prototype.hasScriptBeenAdded = false;
    VimeoFactory.prototype.isAPIReady = false;
    VimeoFactory.prototype.addAPIScript = function() {
      var tag = document.createElement('script');
      tag.src = 'https://player.vimeo.com/api/player.js';
      tag.onload = this.onLoad;

      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      this.hasScriptBeenAdded = true;
    };
    VimeoFactory.prototype.onLoad = function() {
      this.isAPIReady = true;

      // now that the API is ready, initialise each element that was called
      // before the script was loaded.
      if (this.backlog.length) {
        for (var i = 0; i < this.backlog.length; i++) {
          var tmp = this.backlog[i];

          this._initialiseElement(tmp.iframeElement, tmp.properties);
        }
      }
    };
    VimeoFactory.prototype.initialise = function(iframeElement, properties) {
      if (! this.hasScriptBeenAdded) {
        this.addAPIScript();
      }

      if (this.isAPIReady) {
        this._initialiseElement(iframeElement, properties);
      } else {
        this.backlog.push({
          iframeElement: iframeElement,
          properties: properties
        });
      }
    };
    VimeoFactory.prototype._initialiseElement = function(iframeElement, properties) {
      var tmp = new window.CollectiveShift.Analytics.VideoEmbeds.Vimeo(
        iframeElement,
        analyticsProperties(iframeElement, properties)
      );
      tmp.initialise();
    };

    window.CollectiveShift.Analytics.VideoEmbeds.VimeoFactory = new VimeoFactory();
  }


  if (! window.CollectiveShift.Analytics.VideoEmbeds.YouTube) {
    var YouTube = function(element, analytics) {
      this.element = element;
      this.analytics = analytics;

      this.onStateChange = this.onStateChange.bind(this);
      this.progress = this.progress.bind(this);
    };
    YouTube.prototype.started = false;
    YouTube.prototype.duration = undefined;
    YouTube.prototype.progressTracker = undefined;
    YouTube.prototype.playbackPercentage = 0;
    YouTube.prototype.onStateChange = function(event) {
      var state = event.data;

      switch (state) {
        case window.YT.PlayerState.PLAYING:
          this.videoPlayed();

          if (! this.duration) {
            this.duration = this.player.getDuration();
          }

          this.trackProgress();
          break;
        case window.YT.PlayerState.PAUSED:
          this.videoPaused();

          this.stopTrackingProgress();
          break;
        case window.YT.PlayerState.ENDED:
          this.videoEnded();

          this.stopTrackingProgress();
          break;
      }
    };
    YouTube.prototype.videoEnded = videoEnded;
    YouTube.prototype.videoPaused = videoPaused;
    YouTube.prototype.videoPlayed = videoPlayed;
    YouTube.prototype.initialise = function() {
      if (window.YT) {
        this.player = new window.YT.Player(
          this.element,
          {
            events: {
              'onStateChange': this.onStateChange
            }
          }
        );
      }
    };
    YouTube.prototype.fireEvent = function(eventName) {
      var properties = Object.assign({}, this.analytics);

      properties.video_name = this.player.getVideoData().title;

      if (window.CSAnalytics) {
        window.CSAnalytics(eventName, properties);
      }
    };
    /**
     * progress is triggered every 1 second while the video plays. It monitors
     * the % completion for the video, and fires the appropriate event once we
     * hit the milestones.
     */
    YouTube.prototype.progress = function() {
      var currentTime = this.player.getCurrentTime();

      if (this.duration) {
        var percentage = (currentTime / this.duration) * 100;

        if ((percentage >= 25) && (this.playbackPercentage < 25)) {
          this.fireEvent('Video Watched 25%');
        }
        if ((percentage >= 50) && (this.playbackPercentage < 50)) {
          this.fireEvent('Video Watched 50%');
        }
        if ((percentage >= 75) && (this.playbackPercentage < 75)) {
          this.fireEvent('Video Watched 75%');
        }

        // update the stored value for next time.
        this.playbackPercentage = percentage;
      }
    };
    YouTube.prototype.trackProgress = function() {
      this.progressTracker = window.setInterval(this.progress, 1000);
    };
    YouTube.prototype.stopTrackingProgress = function() {
      if (this.progressTracker) {
        window.clearInterval(this.progressTracker);
        this.progressTracker = undefined;
      }
    };

    window.CollectiveShift.Analytics.VideoEmbeds.YouTube = YouTube;
  }


  if (! window.CollectiveShift.Analytics.VideoEmbeds.YouTubeFactory) {
    /**
     * A factory class for loading and initialising the YouTube Iframe API for
     * analytics.
     * We load the Iframe API dynamically, as the documentation suggests, so we
     * use this factory to handle that loading, and delaying any actual
     * processing until the API library is ready.
     */
    var YouTubeFactory = function() {
      this.backlog = [];

      this.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);
    };
    YouTubeFactory.prototype.hasScriptBeenAdded = false;
    YouTubeFactory.prototype.isAPIReady = false;
    YouTubeFactory.prototype.addAPIScript = function() {
      // publish ourselves so we run when teh script loads.
      window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady;

      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      this.hasScriptBeenAdded = true;
    };
    YouTubeFactory.prototype.onYouTubeIframeAPIReady = function() {
      this.isAPIReady = true;

      // now that the API is ready, initialise each element that was called
      // before the script was loaded.
      if (this.backlog.length) {
        for (var i = 0; i < this.backlog.length; i++) {
          var tmp = this.backlog[i];

          this._initialiseElement(tmp.iframeElement, tmp.properties);
        }
      }
    };
    YouTubeFactory.prototype.initialise = function(iframeElement, properties) {
      if (! this.hasScriptBeenAdded) {
        this.addAPIScript();
      }

      if (this.isAPIReady) {
        this._initialiseElement(iframeElement, properties);
      } else {
        this.backlog.push({
          iframeElement: iframeElement,
          properties: properties
        });
      }
    };
    YouTubeFactory.prototype._initialiseElement = function(iframeElement, properties) {
      var tmp = new window.CollectiveShift.Analytics.VideoEmbeds.YouTube(
        iframeElement,
        analyticsProperties(iframeElement, properties)
      );
      tmp.initialise();
    };

    window.CollectiveShift.Analytics.VideoEmbeds.YouTubeFactory = new YouTubeFactory();
  }
};

